<template>
	<div>
		<k-modal
			id="workflowHistoryMessageModal"
			:title="title"
			:okTitle="$t('commons.confirm')"
			okVariant="info"
			:cancelTitle="$t('buttons.cancel')"
			cancelVariant="outline-info"
			size="lg"
			@ok="okEvent"
			@cancel="cancelEvent"
			@hidden="cleanModal"
			:error="modalError"
		>
			<template v-slot:content>
				<b-row class="details mx-4">
					<k-crud ref="workflowHistoryMessageKCrud" :fields="structure" :data="data" />
				</b-row>
			</template>
		</k-modal>
	</div>
</template>

<script>
import KModal from "./KModal.vue";
import KCrud from "../ui/KCrud.vue";

export default {
	components: { KModal, KCrud },

	data() {
		let data = {
			actionId: 0,
			message: "",
			acao: "",
			tipo: 0,
			destinationStepIdActor: 0,
			buttonColor: "info"
		};

		let title = this.$t("modals.workflowHistoryMessage.title");

		let modalError = {
			message: this.$t("modals.workflowHistoryMessage.saveFail"),
			title: this.$t("commons.error"),
			show: false
		};

		let structure = [
			{
				rowNum: 0,
				width: "12",
				label: this.$t("modals.workflowHistoryMessage.message"),
				type: "textArea",
				name: "message"
			}
		];
		return { data, structure, title, modalError };
	},

	methods: {
		setTitle: function (text) {
			this.title = text;
		},
		setAcao(action) {
			this.data.acao = action.nomeAcao;
			this.data.actionId = action.idStep;
			this.data.tipo = action.tipo;
			this.data.destinationStepIdActor = action.destinationStepIdActor;
			this.data.buttonColor = action.buttonColor
		},
		okEvent: function () {
			let dataCopy = JSON.parse(JSON.stringify(this.data));
			this.$emit("confirm", dataCopy);
		},
		cancelEvent: function () {
			this.$emit("cancel");
		},
		cleanModal: function () {
			this.data.message = "";
			this.modalError.show = false;
			this.$emit("cancel");
		}
	},
	computed: {
		modalBtnOkText: function () {
			return this.$t("buttons.ok");
		}
	}
};
</script>

<style scoped></style>
